/**
 * 日历桥方法封装（基于 business/home/calendar JSBridge）
 * 使用 Native.callNative 调用，时间参数为秒级时间戳
 */

import { Native } from '@hb/hbridge';

const CLASS_MAP = 'business/home/calendar';

/**
 * 循环创建日历提醒（连续多天）
 * @param {object} params
 * @param {string} params.title - 事件标题
 * @param {string} [params.description] - 事件描述
 * @param {number} params.startTime - 第一天开始时间（秒级时间戳）
 * @param {number} [params.endTime] - 第一天结束时间（秒级时间戳）
 * @param {number} params.days - 循环天数 [1, 365]
 */
export function addRecurringCalendarEvents(params) {
  return Native.callNative({
    classMap: CLASS_MAP,
    method: 'addRecurringCalendarEvents',
    params: {
      title: params.title,
      description: params.description || '',
      startTime: params.startTime,
      endTime: params.endTime || 0,
      location: params.location || '',
      allDay: params.allDay || false,
      days: params.days,
    },
    timeout: false,
  });
}

/**
 * 按 title 批量删除日历事件
 * @param {object} params
 * @param {string} params.title - 事件标题，精确匹配
 */
export function deleteEventsByTitle(params) {
  return Native.callNative({
    classMap: CLASS_MAP,
    method: 'deleteEventsByTitle',
    params: {
      title: params.title,
    },
    timeout: false,
  });
}
